import { render, staticRenderFns } from "./InstrumentsControl.vue?vue&type=template&id=5c6fc57d&"
import script from "./InstrumentsControl.vue?vue&type=script&lang=js&"
export * from "./InstrumentsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports